<template>
<div>
 <div class="add-hkCard" ref="accountInfo" v-loading="loading">
    <bCardHeader :param="param" :buttons="buttons"></bCardHeader>
    <el-row :gutter="30" class="m-0">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="nopadding">
        <el-row class="m15">
          <div class="card-base card-shadow--small add-hkCard-page">
            <div class="accountinfo-title" test_id="personal_info">{{$t('accountInfo.addCard')}}</div>
            <el-form ref="form" :model="form" label-position="top">
              <el-form-item :label="$t('accountInfo.bankName')">
                <el-select
                    v-model="form.bankCode"
                    filterable
                    :placeholder="$t('common.please_select')"
                    class="currency-select"
                  >
                  <el-option
                    v-for="(item,index) in bankList"
                    :key="index"
                    :label="item.bankName"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input v-model="form.bankName">
                </el-input> -->
              </el-form-item>
              <el-form-item :label="$t('accountInfo.bankNum')">
                <el-input v-model="form.bankAccount" @input="changeBankAccount">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('accountInfo.englishName')">
                <el-input v-model="form.englishName" disabled>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('accountInfo.chineseName')">
                <el-input v-model="form.holder" disabled>
                </el-input>
              </el-form-item>
                <el-form-item
                  class="currency"
                  :label="$t('accountInfo.currency')"
                >
                  <el-select
                    v-model="form.currency"
                    :placeholder="$t('common.please_select')"
                    class="currency-select"
                  >
                  <el-option
                    v-for="(item,index) in currencyOption"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="uploads">
              <div class="upload-title">{{$t('accountInfo.uploadTitle')}}</div>
              <bUploadImage
                ref="uploadImg"
                class="upload"
                @handleRemove="handleRemove"
                @successHandle="successHandle"
                @errHandle="errHandle"
                @progressHandle="progressHandle"
                @uploadHandle="uploadHandle"
                business='bucketBank'/>
              <div class="upload-content" v-html="$t('accountInfo.uploadTips')"></div>
              <div class="upload-content">{{$t('accountInfo.uploadNotice')}}</div>
            </div>
              <el-form-item class="text-center">
                <el-button test_id="button_submit" :disabled="disabledSubmit" type="primary" class="el-button-sub" @click="submitFn">{{$t('common.submit')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="nopadding">
        <div class="card-base card-shadow--small m15" test_id="bank_info">
          <bThreeList
            :params="recordsData"
            :src='src'
            :text="$t('accountInfo.noRecords')"
            :isShowMore="false"
          />
        </div>
      </el-col>
    </el-row>
    <bDialog
      @closeChange="closeChange"
      :dialogVisible.sync="dialogParams.IsCodeShow"
      :closeModal="dialogParams.closeModal"
      :params="dialogParams"
      :component="dialogParams.componentDialog"
      :contiune="dialogParams.contiune"
      :showClose="dialogParams.showClose"
    />
    <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="warn-dialog" :show-close="false">
      <div class="dialog-info">{{$t('accountInfo.withdrawalLimit')}}</div>
      <div class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
      </div>
    </el-dialog>
  </div>
</div>

</template>

<script>
import { mapGetters } from 'vuex'
// import proxyApi from '@/api/proxy-api'
import complete from './info-dialog.vue'
import { getmyBankRecords, addUserBank } from '@/api/v2/deposit'
import { getAllBank, queryWithdrawalLimit } from '@/api/v2/fund'
export default {
  data () {
    return {
      account: {
        cbm: {
          icon: require('@/assets/images/banklogo/OTHER.png'),
          title: 'China Merchants Bank',
          acc_num: '6227 0028 7384 1344 291'
        }
      },
      allLoading: false,
      buttons: [],
      param: {
        title: 'account_info',
        links: [
          { title: 'home' },
          { title: 'my_account' },
          { title: 'account_info' },
          { title: 'add-hkCard' }
        ]
      },
      src: require('@/assets/images/noDeposit.png'),
      bankInfo: [],
      personalInfo: this.$getProfile(),
      accountInfo: '',
      accountInfoHaveBalance: [],
      continueArr: ['IB', 'MF'],
      loadingFailTip: this.$t('common.loadingFailTip'),
      form: {
        bankCode: '',
        bankAccount: '',
        englishName: '',
        holder: '',
        currency: '',
        images: []
      },
      currencyOption: [
        {
          label: this.$t('accountInfo.currencyOpt.CNY'),
          value: 'CNY'
        },
        {
          label: this.$t('accountInfo.currencyOpt.USD'),
          value: 'USD'
        },
        {
          label: this.$t('accountInfo.currencyOpt.HKD'),
          value: 'HKD'
        }
      ],
      disabledSubmit: false,
      recordsData: [],
      dialogParams: {
        IsCodeShow: false,
        closeModal: false,
        orderId: '',
        showClose: false, // 申请码关闭小图标
        contiune: true, // 申请码继续按钮
        componentDialog: complete // 申请码弹窗内容
      },
      loading: false,
      bankList: [], // 银行列表
      dialogtitle: this.$t('logout.tips'),
      showDialog: false
    }
  },

  async mounted () {
    const { name, firstName, lastName } = this.getClientProfile.userInfo
    this.form.englishName = (firstName && lastName) ? `${firstName} ${lastName}` : ''
    this.form.holder = name
    this.queryWithdrawalLimit()
    await this.getBankList()
    this.getAllBankFun()
  },
  computed: {
    ...mapGetters(['getClientProfile', 'getAccountInfo']),
    clientInfo () {
      return this.getClientProfile.userInfo
    }
  },
  methods: {
    async getBankList () {
      this.recordsData = []
      const result = await getmyBankRecords()
      const newStatus = new Map([['REFUSE', 'REJECT'], ['UNPROCESSED', 'SUBMITTED'], ['SUCCESS', 'COMPLETED']]) // 转换状态
      result.data && result.data.forEach(item => {
        // 替换银行卡号key
        // const { bankName, currency, createdTime } = item.childList
        item.childList = {
          bankNum: item.bankNumber,
          bankName: item.bankName,
          currency: this.$t('accountInfo.currencyOpt')[item.currency],
          tradeAccountType: this.$t(`tradeAccountType.${item.tradeAccountType}`),
          fundBankType: item.actionType === 'BANK_SECURITIES_UNBIND' ? this.$t('common.BANK_SECURITIES_UNBIND') : this.$t('common.BANK_SECURITIES_ADD'),
          createdTime: item.createdDate
        }
        delete item.orderId
        item.status = (newStatus.has(item.status) && newStatus.get(item.status)) || item.status
        if (!item.remark) delete item.remark
        if (item.bankType !== 'BANK_SECURITIES') {
          delete item.childList.fundBankType
        }
        if (!item.tradeAccountType) {
          delete item.childList.tradeAccountType
        }
        this.recordsData.push(item)
      })
    },
    closeChange () {
      this.$router.replace('account-info')
    },
    uploadHandle (imageKey) {
      console.log('imageKey>>>>>>', imageKey)
      this.form.images = imageKey
      console.log(this.form.images)
    },
    handleRemove (index) {
      this.form.images.splice(index, 1)
    },
    successHandle () {
      this.disabledSubmit = false
    },
    errHandle () {
      this.disabledSubmit = false
    },
    progressHandle () {
      this.disabledSubmit = true
    },
    async submitFn () {
      console.log('=======form', this.form)
      const { bankCode, bankAccount, images, currency } = this.form
      if (!bankCode) return this.$message.error(this.$t('accountInfo.error.bankNamePlaceholder'))
      if (!bankAccount) return this.$message.error(this.$t('accountInfo.error.bankAccountPlaceholder'))
      if (!currency) return this.$message.error(this.$t('accountInfo.error.currencyPlaceholder'))
      if (!images.length) return this.$message.error(this.$t('accountInfo.error.otherCurrencyPlaceholder'))
      try {
        const params = {
        //   proxyUrl: 'client/clientInfo/createBankClientInfoTmp',
        //   modifiedInfo: { bankAccount: [this.form] },
        //   accountNumber: this.getAccountInfo.accountNumber,
          ...this.form,
          submitSource: 'CP_WEB',
          type: 'HK'
        }
        this.loading = true
        let result = await addUserBank(params)
        if (!result) {
        this.$message.error(this.$t('accountInfo.error.failed'))
        } else if (result.code !== 200) {
          this.$message.error(this.$t(`accountInfo.error.${result.code}`))
        } else {
          this.dialogParams.IsCodeShow = true
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        e && this.$message.error(e.msg)
      }
    },
    async getAllBankFun () {
      let params = {
        isSib: false
      }
      let res = await getAllBank(params)
      this.bankList = res.data || []
      console.log(res, '-0-0-0-')
    },
    changeBankAccount (val) {
      this.form.bankAccount = val.replace(/[^\d]/g, '')
    },
    // 查询是否禁止出金
    async queryWithdrawalLimit() {
      let res = await queryWithdrawalLimit()
      if (res && res.code === 200) {
        this.showDialog = res.data && res.data.isForbidWithdrawal
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../assets/scss/_variables.scss";
.add-hkCard{
  height: min-content;
  .warn-dialog {
    .dialog-info {
      font-size: 14px;
      font-weight: 400;
      color: #7d7d7d;
      line-height: 21px;
      &:first-of-type {
      margin-bottom: 15px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .el-button {
        padding: 18px 96px;
        background: #fec000;
        border-radius: 5px;
        color: #192b57;
        font-size: 14px;
      }
    }
  }
}
.add-hkCard-page {
  padding: 20px 30px;
  margin-bottom: 20px;

  .el-upload--picture-card {
    background-color: #fff !important;
    border: 1px dashed #f9c114 !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    width: 60px !important;
    height: 60px !important;
    cursor: pointer;
    line-height: 60px !important;
    vertical-align: top;
    margin: 10px 0;
  }

  .el-upload--picture-card i {
    color: #f9c114 !important;
    font-size: 18px !important;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    color: #333 !important;
    font-weight: bold;
  }

  .el-button--primary {
    margin-top: 20px;
    color: #333 !important;
    font-weight: bold !important;
    box-shadow:0px 3px 7px 0px rgba(255,209,17,1);
  }
  .upload-title {
    font-weight: 600;
  }
  .uploads {
    color: #7D7D7D;
    font-size: 12px;
  }
  .upload-content {
    font-weight: 400;
  }
  .upload {
    width: 50px;
  }
  .accountinfo-title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0 0 20px;
    padding-bottom: 20px;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;
    letter-spacing: 0.22px;
  }
  .currency-select {
    width: 100%;
  }
  .add-card {
    height: 80px;
    border-radius: 10px;
    box-shadow:0px 3px 7px 0px rgba(179,179,179,0.5);
    line-height: 80px;
    padding-left: 20px;
    span:first-of-type {
      display: inline-block;
      font-size: 25px;
      color: #FEC703;
      margin-right: 10px;
    }
    span:last-of-type {
      font-size: 15px;
      color: #666;
    }
  }
  .card-list {
    border-bottom: 1px solid #e2e2e2;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    .info-name {
      font-family: Muli-Regular;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0.13px;
      min-width: 50px;
    }
    .info-value {
      font-family: Muli-Bold;
      font-size: 16px;
      color: #24282d;
      letter-spacing: 0.19px;
      text-align: right;
    }
    .info-value-cn {
      font-family: "PingFangSC-Semibold";
    }
  }
  .el-card {
    background: #ffffff;
    box-shadow: 0 3px 7px 0 rgba(179, 179, 179, 0.5);
    border-radius: 10px;
  }
  .trading-account {
    border-left: 3px solid #fec000;
  }
  .trade-type-name {
    float: left;
    text-align: left;
    span {
      font-family: Muli-Bold;
      font-size: 18px;
      color: #24282d;
      letter-spacing: 0.22px;
      line-height: 26px;
    }
  }
  .trade-type-value {
    float: right;
    text-align: right;
    padding-bottom: 10px;
    div {
      padding-bottom: 5px;
    }
    .text {
      font-family: Muli-Bold;
      font-size: 16px;
      color: #182a54;
      letter-spacing: 0.14px;
      text-align: right;
      line-height: 16px;
    }
    .balance {
      font-family: Muli-Bold;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0.19px;
      text-align: right;
      line-height: 20px;
    }
    .v-balance {
      font-family: Muli-Bold;
      font-size: 16px;
      color: #2a2a2a;
      letter-spacing: 0.19px;
      text-align: right;
      line-height: 20px;
    }
  }
  .page-eddid-bank-account .el-card__body .img-div {
    left: 20px;
  }
  .ecard {
    margin-top: 30px;
    font-family: Muli-Regular;
    font-size: 16px;
    color: #7d7d7d;
    letter-spacing: 0.14px;
    line-height: 20px;
    padding-top: 20px;
    border-top: 1px solid #e2e2e2;
    div {
      margin: 10px 0 30px 0;
      font-family: Muli-Bold;
      font-size: 16px;
      color: #24282d;
      letter-spacing: 0.14px;
    }
  }
}

.text {
  font-weight: bold;
  font-size: 17px;
}

.bankInfo {
  margin-bottom: 20px;
  .bank-logo {
    display: inline-block;
    width: 55px !important;
    height: 55px !important;
    border-radius: 50% !important;
    margin-right: 20px;
  }
  .bank-list {
    display: flex;
    flex-direction: column;
    .line1 {
      margin-bottom: 10px;
    }
  }
}
.mt-30 {
  margin-top: 30px;
}
.p-40 {
  padding: 40px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.lh-22 {
  line-height: 22px;
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
}

</style>
